import { render, staticRenderFns } from "./RecordIndex.vue?vue&type=template&id=3e79814c&"
import script from "./RecordIndex.vue?vue&type=script&lang=js&"
export * from "./RecordIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports